import React, { useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import TopInfo from "../../components/TopInfo/index";
import BalanceInfo from "../../components/BalanceInfo/index";
import Customcard from "../../components/Customcard/index";
import TopLevel from "../../components/TopLevel/index";
const Index = (props) => {
  const [activeDay, setactiveDay] = useState(1);
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <TopInfo />
     

      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>
        <div className='card-custom w-100 p-3 radius-custom d-flex flex-column justify-content-center align-items-center'>
          <div className='w-100  d-flex flex-column justify-content-center align-items-center'>
            <div className='img' style={{ width: "100px", height: "100px" }}>
                      <img src={`${routeLink.domain}/assets/imgs/gift.png`} className='w-100 h-100 object-fit-contain ' />
            </div>
            <h4 className='text-white fs-extra d-flex m-0 mb-1'>Daily Reward</h4>
            <span className='text-white w-75 text-center'>Collect your daily PAWS rewards by clicking on the button below</span>

          </div>

          <div className='list-grid-4 w-100'>
            {Array.from({ length: 28 }, (_, i) => i + 1).map((value, index) => {
              
                return   <div key={index} className={`card-custom w-100 p-2 card-daily  radius-custom d-flex flex-column justify-content-center align-items-center  mt-2 ${activeDay==(value)?"active":""}`}>
                  <h4 className='text-white  d-flex m-0 mb-2'>Day {value}</h4>
                  <div className='card-icon mb-2'  style={{ width: "30px", height: "30px" }}> 
                    <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
                  </div>
                  <span className='fw-bold color-sub-pri'>30</span>
                  </div>

            })}
          </div>

          <button className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2 w-75 mt-2'>
                <span className='text-white fw-bold'>Collect</span>
          </button>
        </div>


      </div>

    </div>
  )
}

export default Index;
